import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
/**
 * Scrolls window to the top on every route change.
 * Uses 'instant' behavior so navigation feels snappy
 * regardless of the global smooth-scroll CSS rule.
 */
export function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    // Disable browser's automatic scroll restoration on back/forward
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' as ScrollBehavior
    });
  }, [pathname]);
  return null;
}